<nav class="sub-nav">
    <ul class="sub-nav-list">
        <li class="sub-nav-item" *ngFor="let nav of bottomNav"
            [ngClass]="{ 'active-nav': currentUrl.includes(nav.route) }">
            <div class="nav-btn" (click)="navigateTo(nav)">
                <i [class]="nav.icon"></i>
                <span>{{ nav.name }}</span>
            </div>
        </li>
    </ul>
    @if (currentUrl.includes('/dashboard')) {
        <div class="sub-nav-actions">
            <app-layout-chooser></app-layout-chooser>
        </div>
    }
</nav>